
export default function IconExePploads() {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_8156605"
    >
      <g id="Layer_17">
        <path d="m48.25 38.07a1.5 1.5 0 0 0 0-3h-7.43a1.5 1.5 0 0 0 -1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h7.43a1.5 1.5 0 0 0 0-3h-5.93v-2.86h5.93a1.5 1.5 0 0 0 0-3h-5.93v-2.14z"></path>
        <path d="m23.18 38.07a1.5 1.5 0 0 0 0-3h-7.43a1.5 1.5 0 0 0 -1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h7.43a1.5 1.5 0 0 0 0-3h-5.93v-2.86h5.93a1.5 1.5 0 0 0 0-3h-5.93v-2.14z"></path>
        <path d="m36.05 35.29a1.5 1.5 0 0 0 -2.06.49l-2.22 3.61-2.23-3.61a1.5 1.5 0 1 0 -2.54 1.58l3 4.89-3 4.89a1.51 1.51 0 0 0 .49 2.07 1.52 1.52 0 0 0 .79.22 1.48 1.48 0 0 0 1.27-.71l2.23-3.61 2.22 3.61a1.49 1.49 0 0 0 1.28.71 1.46 1.46 0 0 0 .78-.22 1.5 1.5 0 0 0 .49-2.07l-3-4.89 3-4.89a1.5 1.5 0 0 0 -.5-2.07z"></path>
        <path d="m56.5 30.5h-.57v-12.36a1.46 1.46 0 0 0 -.47-1.08l-14.09-14.06a1.46 1.46 0 0 0 -1.08-.47h-27.22a5 5 0 0 0 -5 5v23h-.57a5 5 0 0 0 -5 5v13a5 5 0 0 0 5 5h.57v3a5 5 0 0 0 5 5h37.86a5 5 0 0 0 5-5v-3h.57a5 5 0 0 0 5-5v-13a5 5 0 0 0 -5-5.03zm-14.71-22.87 9 9h-9zm16.71 40.87a2 2 0 0 1 -2 2h-49a2 2 0 0 1 -2-2v-13a2 2 0 0 1 2-2h49a2 2 0 0 1 2 2z"></path>
      </g>
    </svg>
  );
}
